<script>
export default {
  name: 'BitrixShippersForm',
  render: function(createElement) {
    const formScript = createElement(
      'script',
      {
        attrs: {
          // id: "bx24_form_inline",
          'data-b24-form': 'inline/6/zwmmau',
          'data-skip-moving': true,
        },
      },
      ` (function(w,d,u){
                var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/180000|0);
                var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);
        })(window,document,'https://cdn.bitrix24.ru/b937185/crm/form/loader_6.js');
        `
    )
    return formScript
  },
}
</script>

<style scoped></style>
